/**

 */

function InitApplication () {
	if (!VerifyCompatibility()) {
		var msg = 'Your browser does not have all necessary HTML5 features. Can not continue';
		VRC.ConfirmationModal.show({msg: msg, type: 'alert'});
		return;
	}

	// Initialise the local save system
	g_localsave_object = new LocalSaveSystem();

	// Initialise remote communication object
	g_remote_object = new Communication();

	// Initialise a wrapper servic IF you want to use promise based calls
	VRC.CommunicationService.init(g_remote_object);

	// initialise master_data object
	g_master_data = new MasterData();

	// Sub pages (Only Voyage planning Planning left!)
	g_voyage_planning = new VoyagePlanning('#event_log_table');

	//We start on the main page, let's initialize all dialogs on this page.
	InitialiseDialogs(G_PAGE['MAIN_PAGE']);

	//And the generic popup
	VRC.PopupManager.init();

	//Initialize Main Data.
	InitialiseMainData();

}

/**
 * Checks if the navigator is online. Update the status text, and set class.
 */
var CheckOnlineStatus = function () {
    var $online_text = $('#online_text');
    if (navigator.onLine) {

        $online_text.toggleClass('online', true);
        $online_text.toggleClass('offline', false);
        $online_text.text('Status: online');
    }
    else {
        $online_text.toggleClass('offline', true);
        $online_text.toggleClass('online', false);
        $online_text.text('Status: offline');
    }
};

CheckOnlineStatus();

window.addEventListener('offline', CheckOnlineStatus);
window.addEventListener('online', CheckOnlineStatus);

/**
 * Loads and initialized the homepage.
 */
var LoadHomePage = function () {
	SetLoginInformation(g_data_list['name'], g_data_list['operator']);
	VRC.CurrentVoyage.init();
	VRC.PortManager.init();
	VRC.VoyageLogEntryManager.load();
	LoadPage(G_PAGE['HOME_PAGE']);

	g_dataIsReady = true;
};

/**
 * Checks if user is online, fetches masterdata, when this is done, show the Login Dialog.
 */
var Login = function () {
	if (navigator.onLine) {
		VRC.LoadingModal.show();
		VRC.CommunicationService.fetchMasterData(g_master_data)
			.done(LoginDialog);
	}
	else {
		var msg = 'Warning: Could not find local storage nor access the Internet. This page can not be used fully until an' +
			'active Internet connection is obtained.';
		VRC.ConfirmationModal.show({msg: msg, type: 'alert'});
		VRC.ErrorHandleService.showMessage('No local data or Internet connection found.', G_MSG_TYPE_ERROR);
	}
};
/**
 * 1. Tries to
 * Initialises the main elements of the page. Local storage is checked and decks and containers are loaded.
 */
function InitialiseMainData () {


	var hasMainData = function () {
		return g_localsave_object.HasLocalStorageItem(G_LS_NAMES['MAIN_VESSEL_DATA']) && g_localsave_object.HasLocalStorageItem(G_LS_NAMES['DECK_DATA'])
	};

	var hasLoginData = function () {
		return g_data_list['id'] !== undefined && g_data_list['type'] !== undefined && g_data_list['hash_code'] !== undefined
	};

	if (hasMainData()) {
		g_data_list = g_localsave_object.GetLocalStorageItem(G_LS_NAMES['MAIN_VESSEL_DATA']);

		VRC.ErrorHandleService.showMessage('Found local data. Re-loading to saved state (if any)', G_MSG_TYPE_NORMAL);

		if (hasLoginData()) {
			LoadLocalState();

			VRC.CommunicationService.fetchMasterData2(g_master_data)
				.done(function (owner, data) {
					g_master_data.ParseMasterData(owner, data);
					VRC.BulkState.init();

					if (!VRC.BulkTankManager.isInitialised()) {
						var loadingBulkTanks = VRC.BulkState.fetchBulkTanks();
						loadingBulkTanks.done(function () {
							LoadHomePage();
						});
					}
					else {
						LoadHomePage();
					}
				}).fail(function (owner, data) {
					//Try getting it from local storage
					g_master_data.LoadMasterData();
					VRC.MasterDataService.init(g_master_data);
					VRC.BulkState.init();
					LoadPage(G_PAGE['HOME_PAGE']);
					g_dataIsReady = true;
				})

		} else {
			//TODO: A pretty crappy error handling? Why not relog automaticly?
			VRC.ErrorHandleService.showMessage('Found local data, but id and type was not set. Try to re-log', G_MSG_TYPE_ERROR);
		}
	} else {
		Login();
	}

}

/**
 * Checks if all necessary HTML5 features are included
 * @return {boolean} if browser is compatible
 */
function VerifyCompatibility () {
	var msg;
	var compatibility = true;

	// Check if local storage is available
	if (localStorage === undefined) {
		msg = 'Your browser does not have localStorage. Can not save or load locally';
		compatibility = false;
	}
	else if ('serviceWorker' in navigator === undefined) {
		msg = 'Your browser does not support service workers. Can not work offline';
		compatibility = false;
	}
	if (!compatibility) {
		VRC.ConfirmationModal.show({msg: msg, type: 'alert'});
	}
	return compatibility;
}


function v136_to_v137_upgrade() {

    var localItems = JSON.parse(localStorage.getItem(G_LS_NAMES['VOYAGE_LOG']));
    _.each(localItems, function(localItem) {
        console.log(localItem);
        if(localItem.event == 130 || localItem.event == 131 || localItem.event == 132 || localItem.event == 133 || localItem.event == 134 || localItem.event == 135) {
            localItem.event = 105;
        }
        else if(localItem.event == 160 || localItem.event == 161 || localItem.event == 162 || localItem.event == 163 || localItem.event == 164 || localItem.event == 165 ||
            localItem.event == 166 || localItem.event == 167 || localItem.event == 168 || localItem.event == 169 || localItem.event == 170 || localItem.event == 171 ||
            localItem.event == 160 || localItem.event == 160) {
            localItem.subEvent = localItem.event;
            localItem.event = 104;
        }
        if(localItem.subEvent == 130 || localItem.subEvent == 131 || localItem.subEvent == 132 || localItem.subEvent == 133 || localItem.subEvent == 134 || localItem.subEvent == 135) {
            localItem.subEvent = -1;
            localItem.event = 105;
        }

    });
    localStorage.setItem(G_LS_NAMES['VOYAGE_LOG'], JSON.stringify(localItems));
    LoadLocalState();
}

/**
 * Main Menu Click,
 * @param p_page_type Page Type, a number. Defined by G_PAGE in Globals.
 * @param p_menu_item The button/link pressed
 * */
function MainMenuClick (p_page_type, p_menu_item) {
	if (!g_dataIsReady) {
		VRC.ErrorHandleService.showMessage('Vessel Client is starting up or you are not logged in. Please wait to the main page is ready, or try to re-log.', G_MSG_TYPE_NORMAL);
		return false;

	}
	if ($(p_menu_item).hasClass('disabled')) {
		return false;
	}

	LoadPage(p_page_type);
	VRC.NavigationView.setActive(p_menu_item);
}

/**
 * Selects action in submenu. Normally opens a apex page (E.g. 'Departure Report', 'Daily Reports').
 * There are some expeptions 'List voyages' and 'Complete Tank Clean Overview'. These use triggers for the button.
 */
function SubMenuChoice (p_select) {
	g_remote_object.FetchHTMLFromServer(g_voyage_planning, ParseWELSForm, 'info', p_select);
}
/**
 * Puts the HTML in the apex popup.
 * @param p_owner (unused)
 * @param p_data HTML from server.
 */
function ParseWELSForm (p_owner, p_data) {
	$("#apex_popup").html(p_data);
	$("#apex_popup").dialog('open');
}

/**
 * Loads a Page by taking the x_menu and x.html.
 *  x.html contains a script tag that initializes another page.
 *
 *  @param p_page_type A pagetype/number defined in G_PAGE
 */
function LoadPage (p_page_type) {
	SavePageState();
	VRC.NavigationView.init();


	if (p_page_type == G_PAGE.DECK_PAGE) {
		$('#menu_content').load('deck_menu.html');
		$('#main_content').load('deck.html');
	}
	else if (p_page_type == G_PAGE.BULK_PAGE) {
		$('#menu_content').load('bulk_menu.html');
		$('#main_content').load('bulk.html');
	}
	else if (p_page_type == G_PAGE.VOYAGE_PAGE) {
		//Menu is loaded in VoyageState.init()
		$('#main_content').load('voyage.html');
	}
	else if (p_page_type == G_PAGE.FUEL_PAGE) {
		$('#menu_content').load('fuel_menu.html');
		$('#main_content').load('fuel.html');
	}
	else if (p_page_type == G_PAGE.HOME_PAGE) {
		$('#menu_content').load('home_menu.html');
		$('#main_content').load('home.html');
	}
	else {

		var msg = 'A page that does not exist has been selected';
		VRC.ConfirmationModal.show({msg: msg, type: 'alert'});
	}
	g_current_page = p_page_type;
    CheckLastSubmit();
	ShowVoyageValidations(p_page_type);
}

/**
 * Checks the last submit flag and pushes a warning message to be displayed when it has gone over a certain limit
 */
function CheckLastSubmit() {

	if(g_data_list.requiredSubmitIntervalHours && g_data_list.requiredSubmitIntervalHours > 0) {

      if(g_data_list.lastSubmitDate) {

        _lastSubmit = moment(g_data_list.lastSubmitDate, g_timeStampFormat);
	    _hoursSinceSubmit = moment().diff(_lastSubmit, 'hours');

        if( _hoursSinceSubmit > g_data_list.requiredSubmitIntervalHours ) {
           VRC.ErrorHandleService.showMessage("You haven't submitted all data in the last " + _hoursSinceSubmit + " hours. Please consider submitting", G_MSG_TYPE_WARNING);
		}
      }
      else {
          VRC.ErrorHandleService.showMessage("You haven't submitted any data yet. Please consider submitting", G_MSG_TYPE_WARNING);
	  }
    }
}

/**
 * Saves page state. Uses g_global_page.
 * TODO: g_global_page should not be a global but sent by parameters
 */
function SavePageState () {
	if (g_current_page == G_PAGE.VOYAGE_PAGE) {
		OnLeavingVoyagePage();
	}
	else if (g_current_page == G_PAGE.FUEL_PAGE) {
		VRC.RobState.save();
	}
	else if (g_current_page == G_PAGE.BULK_PAGE) {
		OnLeavingBulkPage();
	}
	else if (g_current_page == G_PAGE.DECK_PAGE) {
		OnLeavingDeckPage();
	}
}

/**
 * Show validations (if any) from last submit on the given page.
 * @param p_page_type A pagetype/number defined in G_PAGE
 *
 */
function ShowVoyageValidations (p_page) {
	var $validationArea = $('#validation_area');
	if ($validationArea) {
		$validationArea.hide();
	}

	if (!g_localsave_object.HasLocalStorageItem(G_LS_NAMES['VOYAGE_VALIDATIONS'])) {
		return;
	}

	var validations = g_localsave_object.GetLocalStorageItem(G_LS_NAMES['VOYAGE_VALIDATIONS']);
	var page_validations = [];
	var result = '';

	if (p_page == G_PAGE.VOYAGE_PAGE && validations.voyage_log !== undefined) {
		page_validations = validations.voyage_log;
		page_validations = page_validations.concat(validations.vessel_manifest || []);
	}

	else if (p_page == G_PAGE.DECK_PAGE && validations.voyage_deck !== undefined) {
		page_validations = validations.voyage_deck;
		page_validations = page_validations.concat(validations.vessel_manifest);
	}
	else if (p_page == G_PAGE.BULK_PAGE && validations.voyage_bulk !== undefined) {
		page_validations = validations.voyage_bulk;
	}
	else if (p_page == G_PAGE.FUEL_PAGE && validations.voyage_rob !== undefined) {
		page_validations = validations.voyage_rob;
	}

	$.each(page_validations, function () {
		result += this.type + ' : ' + this.message + '  (Error ID: ' + this.id + ')<br/>';
	});
	if (result != '') {
		result = '<span style="font-weight: bold;"> From Previous Submit </span><br/>' + result;
	}

	if ($validationArea) {
		if (result === "") {
			$validationArea.hide();
		} else {
			$validationArea.html(result);
			$validationArea.show();
		}
	}

}


/**
 * Display confirmation box for fetching data
 */
function ConfirmFetchData () {
	var msg = 'This will fetch last submitted data for Voyage Log, Bulk Tanks, ROB and Deck. Continue?';
	var onConfirm = function () {
		FetchData();
	};
	VRC.ConfirmationModal.show({msg: msg, onConfirm: onConfirm});
}

/**
 * Fetches all data and display data as necessary based on which page we are on.
 * Chains the ajaxrequest
 * Will show loading modal as long as all request are loading.
 * @returns a promise which is resolved when all ajax request are resolved.
 */
function FetchData () {
	VRC.LoadingModal.show();
	var deferred = $.Deferred();

	var voyage = VRC.CurrentVoyage.getCurrentVoyage();

	//Fetch data Four ajax requests
	var fetchVoyage = voyage.fetch();
	var fetchVoyageLog = g_voyage_planning.FetchLogEntries();
	var fetchDeckState = FetchDeckStateFromDB();
	var fetchBulkState = VRC.BulkState.fetch();

	//Wait for ALL 4 different ajax requests to be finished.
	$.when(fetchVoyage, fetchVoyageLog, fetchDeckState, fetchBulkState).done(function (v1, v2, v3, v4) {
		VRC.ErrorHandleService.showMessage('Data fetched from server', G_MSG_TYPE_SUCCESS);
		VRC.LoadingModal.hide();
		deferred.resolve();
	});

	return deferred.promise();
}

/**
 * Closes the ajax Popup
 * Used by the Ajax pages with some top.ClosePopup?
 * @param return_msg Optional message to be shown.
 * @constructor
 */
function ClosePopup (return_msg) {
	$('#apex_popup').dialog('close');

	if (return_msg !== undefined) {
		VRC.ErrorHandleService.showMessage(return_msg, G_MSG_TYPE_NORMAL);
	}
}

/**
 * Get version number
 * From html method
 * TODO: Save this somewhere sane and not i DOM.
 */
function GetVersionNumber () {
	return $('.version_no span').text();
}

/**
 * Opens submit dialog for sending data to server.
 * Voyage Log and Bulk/ROB has a relationship and needs to be submitted together to create warnings.
 * Deck is not connected and could be sent individually.
 *
 * Voyage Log, Rob and Bulk Tanks are selected by default, unless on Deck page.
 *
 */
function OpenSubmitDialog () {
	var $submitParams = $('#submit_params');
	$('#submit_text').html('Select whether to Submit everything, just the Deck or Voyage Log, ROB and Bulk Tanks');
	$submitParams.html('' +
		'<label><input type="radio" name="submit_type" value="all" /> All</label></br>' +
		'<label><input type="radio" name="submit_type" value="all_no_deck" checked="checked" /> Voyage Log, ROB and Bulk Tanks</label><br />' +
		'<label><input type="radio" name="submit_type" value="deck" /> Deck Only<br /></label>');

	if (g_current_page == G_PAGE.DECK_PAGE) {
			$submitParams.find('input[value="deck"]').attr('checked', true);
	}

	$('#submit_dialog').dialog('open');
}
/**
 * Closes Submit Dialog
 */
function CloseSubmitDialog () {
	$('#submit_dialog').dialog('close');
}

/**
 * Saves data on current page and submits data based on checkbox values.
 */
function SubmitData () {
	VRC.LoadingModal.show();
	var submitCode = $('#submit_params input[name="submit_type"]:checked').val() || 'all_no_deck';

	//Default callback
	var onSuccess = function () {
		VRC.LoadingModal.hide();
	};

	if (g_current_page == G_PAGE.VOYAGE_PAGE) {
		g_voyage_planning.SaveLogEntries();

		onSuccess = function () {
			g_voyage_planning.DisplayValidations();
			VRC.LoadingModal.hide();
		};
	}
	else if (g_current_page == G_PAGE.FUEL_PAGE) {
		VRC.RobState.save();
	}
	else if (g_current_page == G_PAGE.BULK_PAGE) {
		VRC.BulkState.saveToLocalStorage();
	}
	else if (g_current_page == G_PAGE.DECK_PAGE) {
		SaveLocalState();
	}

	g_remote_object.SubmitAllData(submitCode, onSuccess, null);
	CloseSubmitDialog();
}

/**
 * Here all begins.
 */
$(document).ready(function () {
	InitApplication();
});
